// Cache for audio objects to avoid recreating them
const audioCache = new Map();

export function playSound(path) {
  if (!path) return;
  let audio = audioCache.get(path);

  if (!audio) {
    // Create new audio object if not cached
    audio = new Audio(path);
    audioCache.set(path, audio);
  }

  // Reset audio to beginning
  audio.currentTime = 0;

  // Handle both immediate play (if already loaded) and delayed play (if needs loading)
  const attemptPlay = () => {
    audio.play().catch((error) => {
      console.error('Error playing sound:', error);
    });
  };

  // Try to play immediately
  if (audio.readyState >= 3) {
    // HAVE_FUTURE_DATA or better
    attemptPlay();
  } else {
    // If not ready, wait for it to load
    audio.addEventListener('canplaythrough', attemptPlay, { once: true });
    audio.load(); // Explicitly start loading
  }
}
